import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Form, Dropdown, InputGroup } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { apiHandler } from '../../../api/apihandler';
import { GRADE_LIST, TEACHERS_CONTENT_COUNT_API, TEACHERS_CREATE_ACTIVITY_API, TEACHERS_HELPER_CREATE_API, TEACHERS_HELPER_CREATE_QUESTIONS_API, } from "../../../api/constants";
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import AIResponseListCard from '../../../components/ai/AIResponseListCard';
import Swal from 'sweetalert2'
import QuestionsList from './questions-list';
const typeArray = [
    {
        id: 1,
        name: "Lesson Plan"
    },
    {
        id: 3,
        name: "Activity"
    },
    // {
    //     id: 4,
    //     name: "Quiz"
    // },
    {
        id: 5,
        name: "Home Work"
    },
    {
        id: 2,
        name: "Test"
    },
]

const TeachersHelper = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { typeParam, purposeParam, gradeParam, classParam } = location.state || {};
    // console.log("Location State:", location.state);
    const [gradeList, setGradeList] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState(gradeParam ? gradeParam : '');
    const [selectedClass, setSelectedClass] = useState(classParam ? classParam : '');
    const [showMoreDataLoader, setShowMoreDataLoader] = useState(false);
    const [selectedType, setSelectedType] = useState(typeParam ? typeParam : typeArray[0].id || '');
    const [purpose, setPurpose] = useState(purposeParam ? purposeParam : typeArray[0].name || '');
    const [topic, setTopic] = useState('');
    const [testDate, setTestDate] = useState('');
    const [testDuration, setTestDuration] = useState('');
    const [isWeighted, setIsWeighted] = useState(false);
    const [totalNonWeightedQues, setTotalNonWeightedQues] = useState('');
    const [totalMCQ, setTotalMCQ] = useState('');
    const [mcqWeight, setMCQWeight] = useState('');
    const [totalSAQ, setTotalSAQ] = useState('');
    const [saqWeight, setSAQWeight] = useState('');
    const [totalLAQ, setTotalLAQ] = useState('');
    const [laqWeight, setLAQWeight] = useState('');
    const [specialInstruction, setSpecialInstruction] = useState('');
    const [lessonPlanRefreshKey, setLessonPlanRefreshKey] = useState(0);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [showCustomLoader, setShowCustomLoader] = useState(false); // New state for custom loader

    // Add new state variables for all counters
    const [lessonPlanCount, setLessonPlanCount] = useState(0);
    const [activityCount, setActivityCount] = useState(0);
    const [testCount, setTestCount] = useState(0);
    const [homeworkCount, setHomeworkCount] = useState(0);

    const handleTypeChange = (e) => {
        e.preventDefault();
        const selectedTypeeId = e.target.value;
        setSelectedType(selectedTypeeId);
        setPurpose(typeArray.find(elm => elm.id == selectedTypeeId) || '');
    };

    const handleGradeChange = (e) => {
        e.preventDefault();
        const selectedGradeId = e.target.value;
        // Use == for loose comparison or convert both to string
        const gradeObj = gradeList.find(g => String(g.grade_name.id) === String(selectedGradeId));
        setSelectedGrade(gradeObj || {});
        setSelectedClass(gradeObj?.classes?.[0] || {});
        // console.log("Selected GradeID:", selectedGradeId);
        // console.log("Selected Grade:", gradeObj);
        // console.log("Selected Class:", gradeObj?.classes?.[0] || {});
    };

    const handleClassChange = (e) => {
        e.preventDefault();
        const classId = e.target.value;
        const classObj = (selectedGrade?.classes || []).find(c => String(c.id) == String(classId));
        setSelectedClass(classObj || {});
    };

    useEffect(() => {
        getCounterData()
        getClassList()
    }, []);

    useEffect(() => {
        return () => {
            // Cleanup any running intervals when component unmounts
            hideLoader();
        };
    }, []);

    async function getClassList() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(GRADE_LIST, "POST", {
                page: 1,
                limit: 100,
            })
            if (res.data?.response?.status === 200) {
                setGradeList(res?.data?.data?.grades)
                setSelectedGrade(gradeParam ? gradeParam : res?.data?.data?.grades?.[0] || {});
                setSelectedClass(classParam ? classParam : res?.data?.data?.grades?.[0]?.classes[0] || {});
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    async function getCounterData() {
        setShowMoreDataLoader(true)
        try {
            const res = await apiHandler(TEACHERS_CONTENT_COUNT_API, "POST", {
                page: 1,
                limit: 100,
            })
            if (res.data?.response?.status === 200) {
                setLessonPlanCount(res?.data?.data?.counts?.lesson_plans || 0);
                setActivityCount(res?.data?.data?.counts?.activities || 0);
                setTestCount(res?.data?.data?.counts?.tests || 0);
                setHomeworkCount(res?.data?.data?.counts?.homeworks || 0);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    // Simple but Attractive Custom Loader Component with transparent background
    const CustomLoader = () => (
        <div className="custom-loader-container" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(5px)'
        }}>
            {/* Simple floating particles */}
            <div style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                pointerEvents: 'none'
            }}>
                {[...Array(4)].map((_, i) => (
                    <div
                        key={i}
                        style={{
                            position: 'absolute',
                            width: '6px',
                            height: '6px',
                            backgroundColor: '#6c5ce7',
                            borderRadius: '50%',
                            opacity: 0.6,
                            left: `${20 + i * 20}%`,
                            top: `${15 + i * 15}%`,
                            animation: `simpleFloat ${2 + i * 0.5}s ease-in-out infinite`
                        }}
                    />
                ))}
            </div>

            {/* Main loader container */}
            <div style={{
                position: 'relative',
                marginBottom: '40px'
            }}>
                {/* Simple rotating ring */}
                <div style={{
                    width: '80px',
                    height: '80px',
                    border: '3px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '3px solid #6c5ce7',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>

                {/* Center icon */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '60px',
                    height: '60px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 4px 15px rgba(108, 92, 231, 0.3)',
                    backdropFilter: 'blur(10px)'
                }}>
                    <i className="material-symbols-outlined" style={{
                        fontSize: '28px',
                        color: '#6c5ce7',
                        animation: 'pulse 2s ease-in-out infinite'
                    }}>
                        psychology
                    </i>
                </div>
            </div>

            {/* Simple Loading Text with transparent background */}
            <div style={{
                textAlign: 'center',
                maxWidth: '400px',
                background: 'rgba(255, 255, 255, 0.9)',
                padding: '30px',
                borderRadius: '15px',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)'
            }}>
                <h4 style={{
                    color: '#2c3e50',
                    fontWeight: '600',
                    marginBottom: '15px',
                    fontSize: '24px'
                }}>
                    {loadingMessage || 'Creating your content...'}
                </h4>
                <p style={{
                    color: '#6c757d',
                    fontSize: '16px',
                    marginBottom: '25px',
                    lineHeight: '1.5'
                }}>
                    Please wait a moment while we prepare everything for you.
                </p>

                {/* Simple Progress Bar */}
                <div style={{
                    width: '100%',
                    height: '4px',
                    backgroundColor: 'rgba(240, 240, 240, 0.8)',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    marginBottom: '15px'
                }}>
                    <div style={{
                        height: '100%',
                        background: '#6c5ce7',
                        borderRadius: '10px',
                        width: `${loadingProgress}%`,
                        transition: 'width 0.3s ease'
                    }}></div>
                </div>

                {/* Progress percentage */}
                <div style={{
                    fontSize: '14px',
                    color: '#6c5ce7',
                    fontWeight: '500'
                }}>
                    {loadingProgress}% Complete
                </div>
            </div>

            {/* Simple CSS animations */}
            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                @keyframes pulse {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }
                
                @keyframes simpleFloat {
                    0%, 100% { transform: translateY(0px); }
                    50% { transform: translateY(-15px); }
                }
            `}</style>
        </div>
    );

    // Enhanced loading progress simulation
    const simulateProgress = (type) => {
        setLoadingProgress(0);
        const messages = {
            1: ['Generating Lesson Plan...', 'Processing Content...', 'Finalizing Structure...'],
            2: ['Creating Test Questions...', 'Generating MCQs...', 'Adding Final Touches...'],
            3: ['Designing Activity...', 'Creating Interactive Elements...', 'Preparing Materials...'],
            5: ['Building Homework...', 'Structuring Questions...', 'Adding Instructions...']
        };

        const typeMessages = messages[type] || ['Processing...', 'Almost Done...', 'Finalizing...'];
        let progress = 0;
        let messageIndex = 0;

        const interval = setInterval(() => {
            // Slower progress increment to avoid reaching 100% too quickly
            progress += Math.random() * 8 + 5;

            // Cap at 95% to let API completion handle the final 5%
            if (progress > 95) progress = 95;

            setLoadingProgress(Math.floor(progress));

            // Update messages based on progress
            if (progress > (messageIndex + 1) * 30 && messageIndex < typeMessages.length - 1) {
                messageIndex++;
                setLoadingMessage(typeMessages[messageIndex]);
            }

            // Don't auto-complete to 100% - let API response handle it
        }, 400);

        setLoadingMessage(typeMessages[0]);
        return interval;
    };

    const hideLoader = () => {
        setShowCustomLoader(false);
        setLoadingProgress(0);
        setLoadingMessage('');
    };

    // Simple success message
    const showSuccessMessage = (message, type) => {
        Swal.fire({
            title: 'Success!',
            html: `
                <div style="text-align: center; padding: 15px;">
                    <div style="
                        width: 60px; 
                        height: 60px; 
                        background: #4caf50;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 auto 15px;
                    ">
                        <i class="material-symbols-outlined" style="
                            font-size: 30px; 
                            color: white;
                        ">check_circle</i>
                    </div>
                    <h3 style="
                        color: #2c3e50; 
                        margin: 0 0 10px; 
                        font-weight: 600;
                        font-size: 20px;
                    ">${message}</h3>
                    <p style="
                        color: #6c757d; 
                        font-size: 14px; 
                        margin: 0;
                    ">Your ${getTypeName(type)} has been created successfully!</p>
                </div>
            `,
            icon: null,
            showConfirmButton: true,
            confirmButtonText: 'Great!',
            confirmButtonColor: '#6c5ce7',
            background: '#ffffff'
        }).then(() => {
            setLessonPlanRefreshKey(prev => prev + 1);
        });
    };

    const getTypeName = (type) => {
        const typeNames = {
            1: 'Lesson Plan',
            2: 'Test',
            3: 'Activity',
            5: 'Homework'
        };
        return typeNames[type] || 'Content';
    };

    // Updated API functions with custom loader for create operations
    async function getTeachersHelperAiApi() {
        setShowCustomLoader(true);
        const progressInterval = simulateProgress(1);

        try {
            const res = await apiHandler(TEACHERS_HELPER_CREATE_API, "POST", {
                purpose: purpose?.name || purpose,
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                topic: topic,
                specialInstruction: specialInstruction,
            });

            if (res.data?.response?.status === 200) {
                clearInterval(progressInterval);
                setLoadingProgress(100);

                // Add a small delay to show 100% completion
                setTimeout(() => {
                    setShowCustomLoader(false);
                    showSuccessMessage('Lesson Plan Created!', 1);
                    // Reset form or refresh data if needed
                    setLessonPlanRefreshKey(prev => prev + 1);
                }, 800);
            } else {
                // Handle API error response
                clearInterval(progressInterval);
                setShowCustomLoader(false);
                console.error('API returned error status:', res.data?.response?.status);
            }
            getCounterData()
        } catch (error) {
            clearInterval(progressInterval);
            setShowCustomLoader(false);
            console.error('API call failed:', error);

            // Show error message to user
            Swal.fire({
                title: 'Error!',
                text: 'Failed to create lesson plan. Please try again.',
                icon: 'error',
                confirmButtonColor: '#6c5ce7'
            });
        }
    }

    async function createQuestions() {
        setShowCustomLoader(true);
        const progressInterval = simulateProgress(selectedType);

        let params = null;
        if (isWeighted) {
            params = {
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                purpose: (selectedType === 2 || selectedType === "2") ? (purpose?.name?.toLowerCase() || purpose?.toLowerCase()) : "homework",
                topic: topic,
                specialInstruction: specialInstruction,
                testDate: testDate,
                testDuration: testDuration,
                isWeighted: isWeighted,
                totalMcqQuestions: totalMCQ,
                mcqQuestionWeight: mcqWeight,
                totalSaqQuestions: totalSAQ,
                saqQuestionWeight: saqWeight,
                totalLaqQuestions: totalLAQ,
                laqQuestionWeight: laqWeight
            };
        } else {
            params = {
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                purpose: (selectedType === 2 || selectedType === "2") ? (purpose?.name?.toLowerCase() || purpose?.toLowerCase()) : "homework",
                topic: topic,
                specialInstruction: specialInstruction,
                testDate: testDate,
                testDuration: testDuration,
                isWeighted: isWeighted,
                totalNonWeightedQuestions: totalNonWeightedQues,
            };
        }

        try {
            const res = await apiHandler(TEACHERS_HELPER_CREATE_QUESTIONS_API, "POST", params);

            if (res.data?.response?.status === 200) {
                clearInterval(progressInterval);
                setLoadingProgress(100);

                setTimeout(() => {
                    setShowCustomLoader(false);
                    showSuccessMessage(
                        selectedType === 2 ? 'Test Created!' : 'Homework Created!',
                        selectedType
                    );
                    setLessonPlanRefreshKey(prev => prev + 1);
                }, 800);
            } else {
                clearInterval(progressInterval);
                setShowCustomLoader(false);
                console.error('API returned error status:', res.data?.response?.status);
            }
            getCounterData()
        } catch (error) {
            clearInterval(progressInterval);
            setShowCustomLoader(false);
            console.error('API call failed:', error);

            Swal.fire({
                title: 'Error!',
                text: `Failed to create ${selectedType === 2 ? 'test' : 'homework'}. Please try again.`,
                icon: 'error',
                confirmButtonColor: '#6c5ce7'
            });
        }
    }

    async function createActivityApi() {
        setShowCustomLoader(true);
        const progressInterval = simulateProgress(3);

        try {
            const res = await apiHandler(TEACHERS_CREATE_ACTIVITY_API, "POST", {
                gradeId: selectedGrade?.grade_name?.id || selectedGrade?.grade_id,
                classId: selectedClass?.id || selectedClass?.class_id,
                purpose: "Activity",
                topic: topic,
                specialInstruction: specialInstruction,
            });

            if (res.data?.response?.status === 200) {
                clearInterval(progressInterval);
                setLoadingProgress(100);

                setTimeout(() => {
                    setShowCustomLoader(false);
                    showSuccessMessage('Activity Created!', 3);
                    setLessonPlanRefreshKey(prev => prev + 1);
                }, 800);
            } else {
                clearInterval(progressInterval);
                setShowCustomLoader(false);
                console.error('API returned error status:', res.data?.response?.status);
            }
            getCounterData()
        } catch (error) {
            clearInterval(progressInterval);
            setShowCustomLoader(false);
            console.error('API call failed:', error);

            Swal.fire({
                title: 'Error!',
                text: 'Failed to create activity. Please try again.',
                icon: 'error',
                confirmButtonColor: '#6c5ce7'
            });
        }
    }



    // Keep the original getClassList function using showMoreDataLoader for project loader
    async function getClassList() {
        setShowMoreDataLoader(true) // Keep using project loader for data loading
        try {
            const res = await apiHandler(GRADE_LIST, "POST", {
                page: 1,
                limit: 100,
            })
            if (res.data?.response?.status === 200) {
                setGradeList(res?.data?.data?.grades)
                setSelectedGrade(gradeParam ? gradeParam : res?.data?.data?.grades?.[0] || {});
                setSelectedClass(classParam ? classParam : res?.data?.data?.grades?.[0]?.classes[0] || {});
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowMoreDataLoader(false)
        }
    }

    return (
        <>
            {/* Show project loader for data loading operations */}

            {/* Show custom attractive loader for create operations */}
            {showCustomLoader && <CustomLoader />}

            {
                showMoreDataLoader ?
                    <div className="col-sm-12 text-center">
                        <img src={loader} alt="loader" style={{ height: "100px" }} />
                    </div> :
                    <div id='content-page' className='content-page'>
                        <Container>
                            <Row>
                                <Col lg={8}>
                                    <Container className='relative'>
                                        <Row className="row-eq-height">
                                            <Col md="12">
                                                <Row>
                                                    <Col md="12">
                                                        <Card className="iq-border-radius-20">
                                                            <Card.Body>
                                                                <Row style={{ paddingLeft: "30px", paddingRight: "30px", marginTop: "20px" }}>
                                                                    <Col md="12" className="mb-3">
                                                                        <h3 className="card-title">Teachers Helper</h3>
                                                                        <p>Neque convallis a cras semper auctor. Libero id faucibus nisl tincidunt egetnvallis.</p>
                                                                    </Col>
                                                                </Row>
                                                                <Form className="email-form" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="to" className="col-form-label">What you want to create today?</Form.Label>
                                                                        <Form.Select id="validationDefault04" required value={selectedType} onChange={handleTypeChange}>
                                                                            {typeArray.map((elm, i) => (
                                                                                <option value={elm?.id}>
                                                                                    {elm?.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="cc" className="col-form-label">For which grade?</Form.Label>
                                                                        <Form.Select
                                                                            id="validationDefault04"
                                                                            required
                                                                            value={selectedGrade?.grade_name?.id || selectedGrade?.grade_id}
                                                                            onChange={handleGradeChange}
                                                                        >
                                                                            {gradeList.map((elm, i) => (
                                                                                <option value={elm?.grade_name?.id} key={elm?.grade_name?.id}>
                                                                                    {elm?.grade_name?.name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="cc" className="col-form-label">Add the class you want to create this {selectedClass?.name} for?</Form.Label>
                                                                        <Form.Select
                                                                            id="validationDefault04"
                                                                            required
                                                                            value={selectedClass?.id || selectedClass?.class_id}
                                                                            onChange={handleClassChange}
                                                                        >
                                                                            {(selectedGrade?.classes || []).map((elm, i) => (
                                                                                <option value={elm?.id || elm?.class_id} key={elm?.id || elm?.class_id}>
                                                                                    {elm?.name || elm?.class_name}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                    <Form.Group className="form-group">
                                                                        <Form.Label column sm="12" htmlFor="cc" className="col-form-label">Topics you want to cover: </Form.Label>
                                                                        <Form.Control type="text" id="cc" placeholder="Enter topic here..."
                                                                            value={topic} onChange={(e) => setTopic(e.target.value)} />
                                                                    </Form.Group>
                                                                    {(selectedType == 2 || selectedType == 5) &&
                                                                        <Row>
                                                                            <Col sm={12}>
                                                                                <Form.Group className="form-group">
                                                                                    <Form.Label htmlFor="testDate" className="col-form-label">
                                                                                        {selectedType == 2 ? "Test" : "Home work"} date:
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="date"
                                                                                        id="testDate"
                                                                                        value={testDate}
                                                                                        min={new Date().toISOString().split('T')[0]} // Allow today and future dates
                                                                                        onChange={e => setTestDate(e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                    {
                                                                        (selectedType == 2 || selectedType == 5) &&
                                                                        <>
                                                                            <Row>
                                                                                <Col sm={6}>
                                                                                    <Form.Group className="form-group">
                                                                                        <Form.Label htmlFor="cc" className="col-form-label">{selectedType == 2 ? "Test" : "Home work"} duration:</Form.Label>
                                                                                        <InputGroup>
                                                                                            <Form.Control
                                                                                                type="text"
                                                                                                id="cc"
                                                                                                placeholder="Test duration here..."
                                                                                                value={testDuration}
                                                                                                onChange={(e) => setTestDuration(e.target.value)}
                                                                                                required
                                                                                            />
                                                                                            <InputGroup.Text>Minutes</InputGroup.Text>
                                                                                        </InputGroup>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                                <Col sm={6}>
                                                                                    <Form.Group className="form-group">
                                                                                        <Form.Label htmlFor="trueFalse" className="col-form-label">
                                                                                            Is weighted type?
                                                                                        </Form.Label>
                                                                                        <Form.Select
                                                                                            id="trueFalse"
                                                                                            value={isWeighted ? "true" : "false"}
                                                                                            onChange={e => setIsWeighted(e.target.value === "true")}
                                                                                        >
                                                                                            <option value="false">False</option>
                                                                                            <option value="true">True</option>
                                                                                        </Form.Select>
                                                                                    </Form.Group>
                                                                                </Col>
                                                                            </Row>
                                                                            {isWeighted ? (
                                                                                <>
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc" className="col-form-label">
                                                                                                    Total MCQ questions:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc"
                                                                                                    placeholder="Total MCQ questions"
                                                                                                    value={totalMCQ}
                                                                                                    onChange={(e) => setTotalMCQ(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc2" className="col-form-label">
                                                                                                    MCQ question's weight:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc2"
                                                                                                    placeholder="MCQ question weight"
                                                                                                    value={mcqWeight}
                                                                                                    onChange={(e) => setMCQWeight(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc" className="col-form-label">
                                                                                                    Total Short questions:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc"
                                                                                                    placeholder="Total short questions"
                                                                                                    value={totalSAQ}
                                                                                                    onChange={(e) => setTotalSAQ(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc2" className="col-form-label">
                                                                                                    Short question's weight:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc2"
                                                                                                    placeholder="MCQ question weight"
                                                                                                    value={saqWeight}
                                                                                                    onChange={(e) => setSAQWeight(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc" className="col-form-label">
                                                                                                    Total Long questions:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc"
                                                                                                    placeholder="Total long questions"
                                                                                                    value={totalLAQ}
                                                                                                    onChange={(e) => setTotalLAQ(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                        <Col sm={6}>
                                                                                            <Form.Group className="form-group">
                                                                                                <Form.Label htmlFor="cc2" className="col-form-label">
                                                                                                    Long question's weight:
                                                                                                </Form.Label>
                                                                                                <Form.Control
                                                                                                    type="text"
                                                                                                    id="cc2"
                                                                                                    placeholder="Long question weight"
                                                                                                    value={laqWeight}
                                                                                                    onChange={(e) => setLAQWeight(e.target.value)}
                                                                                                />
                                                                                            </Form.Group>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </>
                                                                            ) : (
                                                                                <Form.Group className="form-group">
                                                                                    <Form.Label htmlFor="cc" className="col-form-label">
                                                                                        Total non weighted questions:
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        id="cc"
                                                                                        placeholder="Total non weighted questions..."
                                                                                        value={totalNonWeightedQues}
                                                                                        onChange={(e) => setTotalNonWeightedQues(e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </Form.Group>
                                                                            )}
                                                                        </>
                                                                    }

                                                                    <Form.Group className="form-group">
                                                                        <Form.Label htmlFor="subject" column sm="12" className="col-form-label">Do you have any special instruction?</Form.Label>
                                                                        <Form.Control as="textarea" className="textarea" rows={5} placeholder="Your special instruction here..."
                                                                            value={specialInstruction} onChange={(e) => setSpecialInstruction(e.target.value)} />
                                                                    </Form.Group>
                                                                    <div className="send-btn pl-3 mb-2 d-flex justify-content-end">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            style={{
                                                                                background: '#5c518b',
                                                                                border: 'none',
                                                                                borderRadius: '8px',
                                                                                padding: '12px 30px',
                                                                                fontWeight: '600',
                                                                                color: '#ffffff',
                                                                                fontSize: '16px',
                                                                                boxShadow: '0 4px 15px rgba(108, 92, 231, 0.3)',
                                                                                transition: 'all 0.3s ease'
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.target.style.transform = 'translateY(-2px)';
                                                                                e.target.style.boxShadow = '0 6px 20px rgba(108, 92, 231, 0.4)';
                                                                                e.target.style.background = '#5a4fcf';
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.target.style.transform = 'translateY(0px)';
                                                                                e.target.style.boxShadow = '0 4px 15px rgba(108, 92, 231, 0.3)';
                                                                                e.target.style.background = '#6c5ce7';
                                                                            }}
                                                                            onClick={() => {
                                                                                if (selectedType == 1) {
                                                                                    getTeachersHelperAiApi()
                                                                                } else if (selectedType == 2) {
                                                                                    createQuestions()
                                                                                } else if (selectedType == 3) {
                                                                                    createActivityApi()
                                                                                } else if (selectedType == 5) {
                                                                                    createQuestions()
                                                                                }
                                                                            }}
                                                                        >
                                                                            <i className="material-symbols-outlined me-2" style={{ fontSize: '20px', verticalAlign: 'middle' }}>auto_awesome</i>
                                                                            Create
                                                                        </button>
                                                                    </div>
                                                                </Form>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                                <Col lg={4}>
                                    {/* Lesson Plans Card - Clean White Theme */}
                                    <Card className="mb-3" style={{
                                        borderRadius: '12px',
                                        border: '1px solid #e9ecef',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                        overflow: 'hidden',
                                        background: '#ffffff'
                                    }}>
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center"
                                            style={{
                                                border: 'none',
                                                padding: '20px 24px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #e9ecef'
                                            }}
                                            onClick={() => {
                                                navigate('/dashboard/app/teachers-helper-list', {
                                                    state: {
                                                        typeParam: 1,
                                                        purposeParam: "Lesson Plan",
                                                        gradeParam: selectedGrade,
                                                        classParam: selectedClass
                                                    }
                                                });
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <h5 style={{
                                                        color: '#212529',
                                                        fontWeight: '500',
                                                        fontSize: '16px',
                                                        margin: '0 0 2px 0'
                                                    }}>
                                                        Lesson Plan List
                                                    </h5>
                                                    <p style={{
                                                        color: '#6c757d',
                                                        fontSize: '12px',
                                                        margin: 0,
                                                        fontWeight: '300'
                                                    }}>
                                                        {lessonPlanCount} Plans created
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                }}>
                                                    <span style={{
                                                        color: '#495057',
                                                        fontWeight: '300',
                                                        fontSize: '14px'
                                                    }}>
                                                        {lessonPlanCount}
                                                    </span>
                                                </div>
                                                <div style={{
                                                    width: '22px',
                                                    height: '32px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    <i className="material-symbols-outlined" style={{
                                                        fontSize: '16px',
                                                        color: 'gray'
                                                    }}>
                                                        arrow_forward_ios
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>

                                    {/* Activity List Card - Clean White Theme */}
                                    <Card className="mb-3" style={{
                                        borderRadius: '12px',
                                        border: '1px solid #e9ecef',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                        overflow: 'hidden',
                                        background: '#ffffff'
                                    }}>
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center"
                                            style={{
                                                border: 'none',
                                                padding: '20px 24px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #e9ecef'
                                            }}
                                            onClick={() => {
                                                navigate('/dashboard/app/activity-list', {
                                                    state: {
                                                        typeParam: 3,
                                                        purposeParam: "Activity",
                                                        gradeParam: selectedGrade,
                                                        classParam: selectedClass
                                                    }
                                                });
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <h5 style={{
                                                        color: '#212529',
                                                        fontWeight: '500',
                                                        fontSize: '16px',
                                                        margin: '0 0 2px 0'
                                                    }}>
                                                        Activity List
                                                    </h5>
                                                    <p style={{
                                                        color: '#6c757d',
                                                        fontSize: '12px',
                                                        margin: 0,
                                                        fontWeight: '300'
                                                    }}>
                                                        {activityCount} Activities created
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                }}>
                                                    <span style={{
                                                        color: '#495057',
                                                        fontWeight: '300',
                                                        fontSize: '14px'
                                                    }}>
                                                        {activityCount}
                                                    </span>
                                                </div>
                                                <div style={{
                                                    width: '22px',
                                                    height: '32px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    <i className="material-symbols-outlined" style={{
                                                        fontSize: '16px',
                                                        color: 'gray'
                                                    }}>
                                                        arrow_forward_ios
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>

                                    {/* Test List Card - Clean White Theme */}
                                    <Card className="mb-3" style={{
                                        borderRadius: '12px',
                                        border: '1px solid #e9ecef',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                        overflow: 'hidden',
                                        background: '#ffffff'
                                    }}>
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center"
                                            style={{
                                                border: 'none',
                                                padding: '20px 24px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #e9ecef'
                                            }}
                                            onClick={() => {
                                                navigate('/dashboard/app/questions-list', {
                                                    state: {
                                                        typeParam: 2,
                                                        purposeParam: "Test",
                                                        gradeParam: selectedGrade,
                                                        classParam: selectedClass
                                                    }
                                                });
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <h5 style={{
                                                        color: '#212529',
                                                        fontWeight: '500',
                                                        fontSize: '16px',
                                                        margin: '0 0 2px 0'
                                                    }}>
                                                        Test List
                                                    </h5>
                                                    <p style={{
                                                        color: '#6c757d',
                                                        fontSize: '12px',
                                                        margin: 0,
                                                        fontWeight: '300'
                                                    }}>
                                                        {testCount} Tests created
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                }}>
                                                    <span style={{
                                                        color: '#495057',
                                                        fontWeight: '300',
                                                        fontSize: '14px'
                                                    }}>
                                                        {testCount}
                                                    </span>
                                                </div>
                                                <div style={{
                                                    width: '22px',
                                                    height: '32px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    <i className="material-symbols-outlined" style={{
                                                        fontSize: '16px',
                                                        color: 'gray'
                                                    }}>
                                                        arrow_forward_ios
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>

                                    {/* Homework List Card - Clean White Theme */}
                                    <Card className="mb-3" style={{
                                        borderRadius: '12px',
                                        border: '1px solid #e9ecef',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                                        overflow: 'hidden',
                                        background: '#ffffff'
                                    }}>
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center"
                                            style={{
                                                border: 'none',
                                                padding: '20px 24px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #e9ecef'
                                            }}
                                            onClick={() => {
                                                navigate('/dashboard/app/home-work-list', {
                                                    state: {
                                                        typeParam: 5,
                                                        purposeParam: "Home Work",
                                                        gradeParam: selectedGrade,
                                                        classParam: selectedClass
                                                    }
                                                });
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <h5 style={{
                                                        color: '#212529',
                                                        fontWeight: '500',
                                                        fontSize: '16px',
                                                        margin: '0 0 2px 0'
                                                    }}>
                                                        Homework List
                                                    </h5>
                                                    <p style={{
                                                        color: '#6c757d',
                                                        fontSize: '12px',
                                                        margin: 0,
                                                        fontWeight: '400'
                                                    }}>
                                                        {homeworkCount} Assignments created
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                }}>
                                                    <span style={{
                                                        color: '#495057',
                                                        fontWeight: '300',
                                                        fontSize: '14px'
                                                    }}>
                                                        {homeworkCount}
                                                    </span>
                                                </div>
                                                <div style={{
                                                    width: '22px',
                                                    height: '32px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end'
                                                }}>
                                                    <i className="material-symbols-outlined" style={{
                                                        fontSize: '16px',
                                                        color: 'gray'
                                                    }}>
                                                        arrow_forward_ios
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>
            }

        </>
    )
}

export default TeachersHelper